/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {FlagOutlined, LinkOutlined, MessageOutlined, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ESTADOANUNCIOS} from "../../Constantes";


const Formulario_Anuncio = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOANUNCIOS.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo del anuncio'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MessageOutlined} nombre={'Descripcion de la coleccion'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={LinkOutlined} nombre={'Link'}
                                  dato={'link'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Anuncio